<template lang="pug">
  .component-create-entity-button
    ModalReveal
      a.fa-stack.fa-lg(slot="trigger")
        i.fa.fa-circle.fa-stack-2x
        i.fa.fa-plus.fa-stack-1x.fa-inverse
      .row
        .columns
          label Name
            input(type="text", v-model="tocType.name")
          label Priority
            input(type="text", v-model="tocType.priority")
        .columns
          label Group
            select(v-model="tocType.group")
              option ALL
              option GENERAL
              option PLAN
      .row.columns.text-center
        button.button(@click="save") Save Toc Type
</template>
<script type="text/babel">
  import ModalReveal from '../../foundation/ModalReveal'
  import EditReportingType from '../../../../pages/backoffice/EditReportingType'
  import KeplerBackofficeSdk from '../../../../lib/kepler/backoffice'

  export default {
    name: 'CreateTocTypeButtonModal',
    components: {EditReportingType, ModalReveal},
    data() {
      return {
        tocType: {
          name: null,
          priority: 0,
          group: 'ALL'
        }
      }
    },
    created() {
    },
    methods: {
      save() {
        KeplerBackofficeSdk.tocTypes.make(this.tocType, () => {
          window.location.reload()
        })
      }
    },
    props: ['item']
  }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// CreateTocTypeButtonModal.vue?6c456e2e